export enum InboxDisplayStatus {
  RESCORED = 'rescored',
  SCORED = 'scored',
  ASSIGNED = 'assigned',
  ASSIGNED_WITH_SPACES = 'assigned_with_spaces',
  NOT_STARTED = 'not_started',
  IN_PROGRESS = 'in_progress',
  SCORING = 'scoring',
  LAUNCHED = 'launched',
  STARTED = 'started',
  ABORTED = 'aborted',
  ABANDONED = 'abandoned',
  DOWNLEVELED = 'downleveled',
  PREREADER = 'prereader',
  COMPLETED = 'completed',
  UNASSIGNED = 'unassigned',
  RESCORING = 'rescoring',
  MUTED = 'muted',
  STUCK_PLACEMENT = 'stuck_placement',
  UNDER_REVIEW = 'underReview',
  ARCHIVED = 'archived',
}

export default {
  DisplayStatus: InboxDisplayStatus,
};
